import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// 定义 Store
export const useUserStore = create(
  persist(
    (set) => ({
      userInfo: null,
      token: '',
      num: 0,
      addNum: () => set((state) => ({ num: state.num + 1 })),
      setUserInfo: (userInfo) => set({ userInfo }),
      setToken: (token) => set({ token }),
      clearAuth: () => set({ userInfo: null, token: '' }),
    }),
    {
      name: 'userStore', // localStorage key
      getStorage: () => localStorage,
    }
  )
);
